import React from 'react';

export default function ConfidenceMeter({ value, size = 'md' }) {
  const normalized = Math.max(0, Math.min(100, value || 0));

  const color =
    normalized >= 75 ? '#10b981' :
    normalized >= 55 ? '#f59e0b' :
    '#ef4444';

  const radius = size === 'sm' ? 24 : size === 'lg' ? 44 : 34;
  const stroke = size === 'sm' ? 4 : size === 'lg' ? 6 : 5;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalized / 100) * circumference;
  const viewSize = (radius + stroke) * 2;
  const center = radius + stroke;

  return (
    <div className="relative inline-flex items-center justify-center">
      <svg width={viewSize} height={viewSize}>
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.05)"
          strokeWidth={stroke}
        />
        {/* Progress arc */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${center} ${center})`}
          style={{ transition: 'stroke-dashoffset 0.5s ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className="font-bold font-mono"
          style={{
            color,
            fontSize: size === 'sm' ? '10px' : size === 'lg' ? '16px' : '13px',
          }}
        >
          {normalized}
        </span>
      </div>
    </div>
  );
}
